import { Fragment, useContext, useState } from "react";
import JobList from "./JobList";
import { useNavigate } from "react-router-dom";
import { GlobalInfo } from "../../Contexts/GlobalContext";
import ClearFilterButton from "../../Components/ClearFilterButton";

function JobBoard( {onUpdateDonations}) {
    
    const navigate = useNavigate();
    const { appUserIsLogin, theme, GetData, toggleSidebar, isSidebarVisible } = useContext(GlobalInfo);

    const [isClearFilter, setIsClearFilter] = useState(false);
    const [filterCount, setFilterCount] = useState(0);
   
    const handleClearFilters = () => {
        setIsClearFilter(true);
        setTimeout(() => setIsClearFilter(false), 0);
    };


    const handleFilterCountChange = (count) => {
        setFilterCount(count); // Update filter count
    };
    return (

        <Fragment> <div className=" ">
            <div className="el-bg-table">
                <div className="d-flex justify-content-between">
                    <div className="d-flex justify-content-between align-items-center" >
                        <div className="d-flex justify-content-between align-items-center" style={{ marginRight: '15px' }}>
                            <h3>Job Board
                            </h3> 
                        </div>
                        {filterCount > 0 && (<ClearFilterButton handleClearFilters={handleClearFilters} />)}
                        {filterCount > 0 && (<span className="m-2">Filters applied: {filterCount}</span>)}
                    </div>
                </div>
                <>
                    <JobList isClearFilter={isClearFilter}   onFilterCountChange={handleFilterCountChange}   type={"donor"}     onUpdateDonations={onUpdateDonations}  />
                </>
            </div>
        </div>
        </Fragment>
    );
}

export default JobBoard